/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Card } from '../../../Shared/Card'
import { useQuery } from '@tanstack/react-query'
import { getPosDevices } from '../../../../../services/PointOfSale/PointOfSale.service'
import { TIME } from '../../../../../services/date.service'
import useUser from '../../../../Shared/UserProvider/useUser'
import { useTranslation } from 'react-i18next'
import { LoadingPlaceholderCardContent } from '../../../Shared/LoadingPlaceholderCardContent'
import { Icon } from 'semantic-ui-react'
import { THEME_COLORS } from '../../../../Shared/theme'
import { IconWithContentCardContent } from '../Shared/IconWithContentCardContent'
import { useDeviceMediaQuery } from '../../../../Shared/UseDeviceMediaQuery/useDeviceMediaQuery'

const DevicesCard = () => {
    const [t] = useTranslation()
    const {user} = useUser()
    const { isMobile } = useDeviceMediaQuery()

    const {data, isLoading} = useQuery({
        queryKey: ['devices', user.provider.object.id],
        queryFn: () => getPosDevices(user.provider.object.id),
        staleTime: TIME.HOUR_IN_MS * 4,
    })

    const noDevices = !isLoading && data.devicesCount === 0

    const getBorderColor = () => {
        if (isLoading) {
            return 'unset'
        }

        return noDevices ? THEME_COLORS.RED : THEME_COLORS.GREEN
    }

    return (
      <Card
        css={css`
            border-top: 2px solid ${getBorderColor()};

            .card-content {
                width: ${isMobile ? '340px' : '360px'};
                height: 110px;
            }
        `}
      >
          {isLoading ? (
            <LoadingPlaceholderCardContent/>
          ) : (
            <IconWithContentCardContent
              iconElement={(
                <>
                    <Icon color="grey" name="tablet alternate"/>
                    <Icon
                      corner
                      name={noDevices ? 'ban' : 'checkmark'}
                      color={noDevices ? 'red' : 'green'}
                    />
                </>
              )}
              contentElement={(
                <p
                  css={css`
                      font-weight: bold;
                  `}
                >
                    {noDevices ?
                      t('device.no_device_connected') :
                      t('device.count_device_connected', {count: data.devicesCount})
                    }
                </p>
              )}
            />
          )}
      </Card>
    )
}

export { DevicesCard }
